module.exports = __webpack_public_path__ + "img/02_uk.5168f4b9.svg";